<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <div class="row">
        <h3>
          Dashboard Access Rules
          <button type="button" class="btn btn-primary btn-sm" (click)="openCreateModal()">
            <fa-icon [icon]="['fal','plus']"></fa-icon> Create Rule
          </button>
        </h3>
      </div>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="lock" size="lg" [fixedWidth]="true"> </fa-icon>
    </div>
    <div class="card-body">
      <p>
        By default the access to the dashboard page is managed under
        <a class="link" routerLinkActive="active" [routerLink]="['/permission']">Permissions</a>.
        <br />
        Access is granted to users with a role that contains the <code>stats:READ</code> permission.
      </p>
      <p>
        On this page that behaviour can be overwritten for specific roles or users.<br />
        Each rule grants access to statistics of users with certain lables (or attributes).<br />
        Multiple rules can be created to grant insight into statistics of more users.
      </p>
      <div class="table-responsive" *ngIf="filters != null">
        <table class="table table-hover">
          <thead class="text-primary">
            <tr>
              <th>Name</th>
              <th>Selector</th>
              <th>Role</th>
              <th>User</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-row" *ngFor="let f of filters">
              <td>{{ f.name }}</td>
              <td>
                <ng-container *ngFor="let l of f.labels | keyvalue; let last = last">
                  <span>{{ l.key }} = {{ l.value }}</span>
                  <span *ngIf="!last">, </span>
                </ng-container>
              </td>
              <td>
                <span *ngIf="f.meta?.roles">
                  <ng-container *ngFor="let r of f.meta?.roles; let last = last">
                    <span>{{ r }}</span>
                    <span *ngIf="!last">, </span>
                  </ng-container>
                </span>
              </td>
              <td>
                <span *ngIf="f.meta?.usernames">
                  <ng-container *ngFor="let u of f.meta?.usernames; let last = last">
                    <span>{{ u }}</span>
                    <span *ngIf="!last">, </span>
                  </ng-container>
                </span>
              </td>
              <td class="text-right">
                <button type="button" class="btn btn-light btn-icon btn-sm" (click)="openUpdateModal(f)">
                  <fa-icon [fixedWidth]="true" [icon]="['fal','cog']"></fa-icon>
                </button>
                <button (click)="deleteSwalOptions(f)" type="button" class="btn btn-danger btn-icon btn-sm ml-1">
                  <fa-icon [fixedWidth]="true" [icon]="['fal','trash']"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
